/**
 * 管理画面用のfetch。認証トークンを自動付与。
 */
export const adminFetch = (url, options = {}) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    const separator = url.includes('?') ? '&' : '?';
    url = url + separator + '_token=' + token;
  }
  return fetch(url, options);
};
